import React, { PropTypes } from 'react'
import { Spin } from 'antd'

const _BtnShowMore = (props) => {
  const {
    product,
    cName,
    num,
    w,
  } = props
  return (
    (
      <div style={{ textAlign: 'center', marginTop: 15, display: product.length > num ? '' : 'none' }}>
        <button className="cws-button small bt-color-5"
          type="primary"
          style={{ width: w, margin: 0 }}
          data-btn-id={cName}
          id={`${cName}-btn`}
        >เพิ่มเติม</button>
        <input type="hidden" id={`${cName}-num`} value={num} />
        <Spin size="large" id={`${cName}-spin`} style={{ display: 'none' }} />
      </div>
    )
  )
}

_BtnShowMore.propTypes = {
  product: PropTypes.array.isRequired,
  cName: PropTypes.string.isRequired,
  num: PropTypes.number.isRequired,
  w: PropTypes.string.isRequired,
}

export default _BtnShowMore



// WEBPACK FOOTER //
// ./src/components/btnShowMore.js